var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{staticClass:"item",on:{"click":_vm.goTo}},[_vm._v(" "+_vm._s(_vm.username)+" さん ")])}
var staticRenderFns = []

export { render, staticRenderFns }